// 获取活动列表
export const GETACTIVITYLIST = 'get-activity-list'
// 获取活动推荐列表
export const GETACTIVITYRECOMMENDLIST = 'get-activity-recommend-list'
// 获取活动举办地址列表
export const GETACTIVITYPLACELIST = 'get-activity-place-list'
// 获取活动举办地址列表
export const GETACTIVITYINFODATA = 'get-activity-info-data'
